(() => {
  'use strict';
  const config = document.querySelector('[data-spin-cart-config]');
  if (!config) return;
  const isUS = config.dataset.country === 'US';
  const isUSCA = isUS || config.dataset.country === 'CA';
  const base = config.dataset.root;
  let offer = null, busy = false, sequence = 0;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}).format(cents / 100);
  const read = async url => {
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('Could not check the cart. Please try again.');
    return response.json();
  };
  const isArctic = item => String(item.product_id) === '7696944562343' || String(item.variant_id || item.id) === '43639599300775' || item.handle === 'arcticglide-skating-synthetic-icepanel-pro-2-pack';
  const updateShipping = cart => {
    const hasArctic = cart.items.some(isArctic);
    window.__arcticShippingCart = hasArctic;
    const hasSpin = cart.items.some(item => [config.dataset.single, config.dataset.dual, config.dataset.elite].includes(String(item.variant_id)));
    window.__spinShippingCart = hasSpin;
    document.querySelectorAll('[data-spin-cart-shipping]').forEach(label => {
      const key = !isUSCA ? 'shippingCheckout' : hasSpin || document.querySelector('.spin-refresh') ? 'shippingUs' : 'shippingUsCa';
      label.textContent = label.dataset[key] || label.textContent;
    });
    const taxesOnly = hasArctic && (isUS || config.dataset.country === 'CA' && !hasSpin);
    document.querySelectorAll('[data-cart-shipping-note]').forEach(note => {
      note.textContent = note.dataset[taxesOnly ? 'shippingTaxOnly' : 'shippingDefault'] || note.textContent;
    });
    if (window.__deliveryPromise) window.__deliveryPromise();
  };
  const fingerprint = cart => JSON.stringify([cart.currency, cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
  const candidate = (cart, product) => {
    if (cart.total_discount > 0) return null;
    const items = cart.items.filter(item => String(item.variant_id) === config.dataset.single);
    if (items.length !== 1) return null;
    const item = items[0];
    if (![2, 3].includes(item.quantity) || item.selling_plan_allocation || Object.keys(item.properties || {}).length) return null;
    const targetId = item.quantity === 2 ? config.dataset.dual : config.dataset.elite;
    if (cart.items.some(line => String(line.variant_id) === targetId)) return null;
    const variant = product.variants.find(v => String(v.id) === targetId);
    if (!variant?.available || variant.price >= item.final_line_price) return null;
    return {item, variant, currency: cart.currency, saving: item.final_line_price - variant.price, fingerprint: fingerprint(cart)};
  };
  const panels = () => [...document.querySelectorAll('[data-spin-bundle-offer]')];
  const show = (next, message = '') => {
    offer = next;
    panels().forEach(panel => {
      panel.hidden = !next && !message;
      const copy = panel.querySelector('[data-spin-bundle-copy]');
      const button = panel.querySelector('button');
      copy.textContent = next ? `Same ${next.item.quantity} Spin Defenders, better bundle price. Switch from ${money(next.item.final_line_price, next.currency)} to ${money(next.variant.price, next.currency)} and save ${money(next.saving, next.currency)}.` : '';
      button.hidden = !next;
      button.disabled = busy;
      panel.querySelector('[role="status"]').textContent = message;
    });
  };
  const refresh = async event => {
    const detail = event && event.detail;
    if (detail && detail.cart && Array.isArray(detail.cart.items)) updateShipping(detail.cart);
    if (busy) return;
    const current = ++sequence;
    try {
      const cart = await read(`${base}cart.js`);
      if (current !== sequence || busy) return;
      updateShipping(cart);
      if (!isUS) { show(null); return; }
      const product = await read(`${base}products/spin-defender-app-controlled-hockey-trainer.js`);
      if (current === sequence && !busy) show(candidate(cart, product));
    } catch (_) { if (current === sequence) show(null); }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-spin-bundle-switch]');
    if (!button || busy || !offer) return;
    event.preventDefault();
    const chosen = offer;
    busy = true;
    ++sequence;
    const controls = [...document.querySelectorAll('#CartPageForm button, #CartPageForm input, #CartDrawerForm button, #CartDrawerForm input')];
    const previous = controls.map(el => el.disabled);
    controls.forEach(el => { el.disabled = true; });
    show(chosen, 'Checking your bundle…');
    try {
      const [cart, product] = await Promise.all([read(`${base}cart.js`), read(`${base}products/spin-defender-app-controlled-hockey-trainer.js`)]);
      const latest = candidate(cart, product);
      if (!latest || latest.fingerprint !== chosen.fingerprint || latest.variant.price !== chosen.variant.price) throw new Error('Your cart or bundle availability changed. Please review the updated offer.');
      const response = await fetch(`${base}cart/update.js`, {
        method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({updates: {[chosen.item.key]: 0, [String(chosen.variant.id)]: 1}})
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || 'The bundle could not be applied. Please review your cart.');
      window.location.assign(config.dataset.cart);
    } catch (error) {
      show(null, `${error.message} Refresh the cart before checking out.`);
      document.dispatchEvent(new CustomEvent('cart:build'));
    } finally {
      busy = false;
      controls.forEach((el, index) => { el.disabled = previous[index]; });
    }
  });
  ['cart:updated', 'ajaxProduct:added', 'cart:open'].forEach(name => document.addEventListener(name, refresh));
  refresh();
})();
